import {createStore, compose, applyMiddleware} from 'redux';
import promise from 'redux-promise-middleware';

import rootReducer from '../reducers';

export default function configureStore(initialState) {
  const middewares = [
    // Add other middleware on this line...

    // promise middleware
    promise(),
  ];

  return createStore(rootReducer, initialState, compose(
    applyMiddleware(...middewares)
    )
  );
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.prod.js
 **/